module.exports = __webpack_public_path__ + "media/pdf/RESQ-banner-dbd543fc.png";